module.exports = __webpack_public_path__ + "158a45876f408a41812778bed252d2ba.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/kotlin-logo.png
// module id = 377
// module chunks = 1